import GlassCard from "@/v2/components/GlassCard";
import { PhoneCall, Lock, CalendarCheck } from "lucide-react";

export default function CallInfoCard({
  tier,
  callUnlockedAt,
}: {
  tier: "self_service" | "with_call";
  callUnlockedAt: string | null;
}) {
  if (tier !== "with_call") return null;
  const unlocked = !!callUnlockedAt;

  return (
    <GlassCard className="!p-5 border-secondary/30">
      <div className="flex items-start gap-3">
        <div className="shrink-0 w-9 h-9 rounded-lg bg-secondary/15 text-secondary inline-flex items-center justify-center">
          {unlocked ? <PhoneCall className="h-4 w-4" /> : <Lock className="h-4 w-4" />}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">
            {unlocked ? "Call di revisione sbloccata" : "Call di revisione"}
          </p>
          <p className="text-xs text-slate-400 mt-1">
            {unlocked
              ? "Hai completato lo Step 3. Prenota la tua sessione 1:1 con Federico per analizzare i dati e decidere il prossimo passo."
              : "Si sblocca al completamento dello Step 3."}
          </p>
          {unlocked && (
            <a
              href="https://calendar.app.google/bqjaW64K5KZ3muFx7"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center gap-2 rounded-full bg-secondary/20 hover:bg-secondary/30 border border-secondary/40 px-4 py-2 text-xs font-semibold text-secondary transition-colors"
            >
              <CalendarCheck className="h-3.5 w-3.5" />
              Prenota la tua call →
            </a>
          )}
        </div>
      </div>
    </GlassCard>
  );
}
